import script from "./es.vue?vue&type=script&lang=js"
export * from "./es.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/languages/es.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1852f76a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1852f76a', __exports__)) {
    api.reload('1852f76a', __exports__)
  }
  
}


export default __exports__